<template>
  <bar-chart :chartdata="chartdata"/>
</template>

<script>
import BarChart from '@/components/charts/bar'

export default {
  name: 'BackupSummaryBar',
  components: {
    BarChart
  },
  props: {
    shelvery: {
      type: Array,
      default: () => []
    },
    automated: {
      type: Array,
      default: () => []
    },
    manual: {
      type: Array,
      default: () => []
    },
    awsbackup: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      chartdata: null
    }
  },
  methods: {
    fillchartdata: function () {
      this.chartdata = {
        labels: [
          'ami',
          'rds',
          'aurora',
          'ebs',
          'redshift',
          'documentdb',
          's3'
        ],
        datasets: [
          {
            label: 'shelvery',
            backgroundColor: '#ef476f',
            data: this.shelvery
          },
          {
            label: 'automated',
            backgroundColor: '#ffd166',
            data: this.automated
          },
          {
            label: 'manual',
            backgroundColor: '#06d6a0',
            data: this.manual
          },
          {
            label: 'awsbackup',
            backgroundColor: '#118ab2',
            data: this.awsbackup
          }
        ]
      }
    }
  },
  created: function () {
    this.fillchartdata()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/charts/BackupSummaryBar.vue